import { useCallback } from 'react';
import { copyToClipboard } from '../../helpers/copyToClipboard';
import { useTimedToggle } from '../../private/hooks/useTimedToggle';

export const useClipboard = (
  textToCopy: string,
  timeout = 1500,
): [() => Promise<void>, boolean, boolean] => {
  const [hasCopied, toggleHasCopied] = useTimedToggle(false);
  const [failedToCopy, toggleFailedToCopy] = useTimedToggle(false);

  const onCopy = useCallback(async () => {
    try {
      await copyToClipboard(textToCopy);

      // if there's no timeout value there's no need to set toggleHasCopied
      if (timeout && timeout > 0) {
        toggleHasCopied(timeout);
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        toggleFailedToCopy(timeout);
      }
    }
  }, [textToCopy, timeout, toggleHasCopied, toggleFailedToCopy]);

  return [onCopy, hasCopied, failedToCopy];
};
